import React from 'react';
import PropTypes from 'prop-types';

import InfoTip from '../Notifications/elements/InfoTip';

export const rate = (clicked, sent) => `${sent ? Math.round((clicked / sent) * 1000) / 10 : 0}%`;

const Stat = ({ value, label, tip }) => (
  <div className='stat'>
    <b>{value}</b>
    <span className='label'>{label}{tip && <InfoTip message={tip} />}</span>
  </div>
);

Stat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  tip: PropTypes.string
};

export default Stat;
